'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var DateHelper = {
  // Console log without worrying about if the browser supports it
  console: function (_console) {
    function console(_x) {
      return _console.apply(this, arguments);
    }

    console.toString = function () {
      return _console.toString();
    };

    return console;
  }(function (message) {
    if (window.console && console.log) console.log('Date Helper: %s', message);
  }),

  // Make a 0 appear before any given string, the length of the returned string is also required
  pad: function pad(str, len) {
    if (!str) return '';
    return (Array(len).join('0') + str).slice(0 - len);
  },

  // This will date a native javascript date and turn into the ISO format we use eg: '2016-11-01'
  nativeDateToIso: function nativeDateToIso(date) {
    if ((typeof date === 'undefined' ? 'undefined' : _typeof(date)) !== 'object') {
      this.console('nativeDateToIso did not get passed a native javascript date object, returning null');
      return null;
    }
    return date.getFullYear() + '-' + this.pad(date.getMonth() + 1, 2) + '-' + this.pad(date.getDate(), 2);
  },

  // Turns a string into a native javascript date, expected input is in this format "14/11/2015"
  parseEnglishDate: function parseEnglishDate(dateString) {
    if (dateString === null || dateString.indexOf('/') === -1) {
      this.console('parseEnglishDate did not find any slashes in the string you passed in, returning null');
      return null;
    }
    var dateSplit = dateString.split('/');
    return dateSplit.length === 3 ? new Date(('20' + dateSplit[2]).slice(-4), dateSplit[1] - 1, dateSplit[0]) : null;
  },

  // Turns a string into a native javascript date, expected input is in this format "2015-11-14"
  parseIsoDate: function parseIsoDate(dateString) {
    if (dateString === null || dateString.indexOf('-') === -1) {
      this.console('parseIsoDate did not find any dashes in the string you passed in, returning null');
      return null;
    }
    var dateSplit = dateString.split('-');
    return dateSplit.length === 3 ? new Date(dateSplit[0], dateSplit[1] - 1, dateSplit[2]) : null;
  },
  getDaysOfTheMonthByLanguage: function getDaysOfTheMonthByLanguage(language) {
    if (!language || language === 'UK') return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    if (language === 'DE' || language === 'AT') return ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
    if (language === 'NL') return ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'];
    if (language === 'FR') return ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'];
    if (language === 'IT') return ['Do', 'Lu', 'Ma', 'Me', 'Gio', 'Ve', 'Sa'];
    if (language === 'PL') return ['Niedz.', 'Pon.', 'Wt.', 'Śr.', 'Czw.', 'Pt.', 'Sob.']
  },
  getMonthNamesByLanguage: function getMonthNamesByLanguage(language) {
    if (!language || language === 'UK') return ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
    if (language === 'DE' || language === 'AT') return ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'];
    if (language === 'NL') return ['Jan', 'Feb', 'Maa', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'];
    if (language === 'FR') return ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Jun', 'Jul', 'Aoû', 'Sep', 'Oct', 'Nov', 'Déc'];
    if (language === 'IT') return ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'];
    if (language === 'PL') return [ 'Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru' ]
  },
  getMonthName: function getMonthName(month, language) {
    var months = this.getMonthNamesByLanguage(language);
    return months[month];
  },
  getFullDay: function getFullDay(day, language) {
    var days = this.getDaysOfTheMonthByLanguage(language);
    return days[day];
  },
  getOrdinal: function getOrdinal(date, language) {
    if (language && language !== 'UK') return '.';
    if (date === 1 || date === 21 || date === 31) return 'st';
    if (date === 2 || date === 22) return 'nd';
    if (date === 3 || date === 23) return 'rd';
    return 'th';
  },

  // returns the amount of months between 2 dates as an integar, e.g. '3'
  getMonthsAgo: function getMonthsAgo(dateFrom, dateTo) {
    if (typeof dateFrom.getDate !== 'function' || typeof dateTo.getDate !== 'function') return '';

    return dateTo.getMonth() - dateFrom.getMonth() + 12 * (dateTo.getFullYear() - dateFrom.getFullYear());
  },

  // This will format a given date to the english date format eg '14/11/2015'
  formatDateToDMY: function formatDateToDMY(date) {
    if (typeof date.getDate !== 'function') {
      return '';
    }
    var newDate = '';
    newDate += this.pad(date.getDate(), 2) + '/';
    newDate += this.pad(date.getMonth() + 1, 2) + '/';
    newDate += this.pad(date.getFullYear().toString().substr(2, 2), 2);
    return newDate;
  },
  formatDateToDddMMyy: function formatDateToDddMMyy(date, language) {
    if (typeof date.getDate !== 'function') {
      return '';
    }
    var newDate = '';
    newDate += this.getFullDay(date.getDay(), language) + ' ';
    newDate += date.getDate() + this.getOrdinal(date.getDate(), language) + ' ';
    newDate += this.getMonthName(date.getMonth(), language) + ' ';
    newDate += date.getFullYear().toString();
    return newDate;
  },

  // Change the day by a certain number of days, accepts native javascript dates and a string such as "+7", or "-4"
  alterDateByNumberOfDays: function alterDateByNumberOfDays(date, instruction) {
    if (!date || !instruction || (typeof date === 'undefined' ? 'undefined' : _typeof(date)) !== 'object') {
      this.console('addDaysToDate produced an error, you must pass in a javascript date object, and a string for the instruction eg: "+7" or "-3" etc.  Returning false');
      return false;
    }
    var customDate = new Date(date.getTime()); // Clone the date that was passed in
    return new Date(customDate.setDate(customDate.getDate() + Number(instruction.toString().replace(/(?!\+|-)[\D]/gi, ''))));
  },
  checkPastDate: function checkPastDate (date) {
    if (!date) return null
    const diff = new Date().getTime() - new Date(date).getTime()
    // Given Date is in Past
    if (diff > 0) return null
    return date
  }
};

module.exports = DateHelper;


//////////////////
// WEBPACK FOOTER
// ./node_modules/static-site-generator-shared/plugins/lib/dateHelper.js
// module id = 46
// module chunks = 119